/**
 * @generated SignedSource<<f1f9a52fc0fcf7970c831acb6974d936>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountDelegatedAuthsId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountDelegatedAuthsId",
    "variableName": "accountDelegatedAuthsId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appData",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveDate",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "t1",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appDescription",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appLogo",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountDelegatedAuthsMapId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mapName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityDescription",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountName",
  "storageKey": null
},
v16 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "psStatus": 0
    }
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "psId",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "psStatus",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "psType",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ccNum",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ccExpy",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ccBrand",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ccLast4",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "extSource",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fiName",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "achAccountNum",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationSetupRecurlyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountDelegatedAuthsT",
        "kind": "LinkedField",
        "name": "accountDelegatedAuthsTByAccountDelegatedAuthsId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AppIntegrationT",
            "kind": "LinkedField",
            "name": "appIntegrationTByAppIntegrationId",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountDelegatedAuthsMapTsConnection",
            "kind": "LinkedField",
            "name": "accountDelegatedAuthsMapTsByAccountDelegatedAuthsId",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountDelegatedAuthsMapT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountTByAccountId",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              {
                "alias": null,
                "args": (v16/*: any*/),
                "concreteType": "PaymentSourceTsConnection",
                "kind": "LinkedField",
                "name": "paymentSourceTsByAccountId",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentSourceT",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "paymentSourceTsByAccountId(condition:{\"psStatus\":0})"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationSetupRecurlyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountDelegatedAuthsT",
        "kind": "LinkedField",
        "name": "accountDelegatedAuthsTByAccountDelegatedAuthsId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AppIntegrationT",
            "kind": "LinkedField",
            "name": "appIntegrationTByAppIntegrationId",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v27/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountDelegatedAuthsMapTsConnection",
            "kind": "LinkedField",
            "name": "accountDelegatedAuthsMapTsByAccountDelegatedAuthsId",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountDelegatedAuthsMapT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v27/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountTByAccountId",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              {
                "alias": null,
                "args": (v16/*: any*/),
                "concreteType": "PaymentSourceTsConnection",
                "kind": "LinkedField",
                "name": "paymentSourceTsByAccountId",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentSourceT",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "paymentSourceTsByAccountId(condition:{\"psStatus\":0})"
              },
              (v27/*: any*/)
            ],
            "storageKey": null
          },
          (v27/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0ce61628d2eb6a06d0d80d61dae8e6e5",
    "id": null,
    "metadata": {},
    "name": "IntegrationSetupRecurlyQuery",
    "operationKind": "query",
    "text": "query IntegrationSetupRecurlyQuery(\n  $accountDelegatedAuthsId: UUID!\n) {\n  accountDelegatedAuthsTByAccountDelegatedAuthsId(accountDelegatedAuthsId: $accountDelegatedAuthsId) {\n    appName\n    authType\n    appData\n    effectiveDate\n    t1\n    appIntegrationTByAppIntegrationId {\n      appDescription\n      appLogo\n      nodeId\n    }\n    accountDelegatedAuthsMapTsByAccountDelegatedAuthsId {\n      totalCount\n      nodes {\n        accountDelegatedAuthsMapId\n        mapName\n        entityId\n        entityName\n        entityDescription\n        nodeId\n      }\n    }\n    accountTByAccountId {\n      accountName\n      paymentSourceTsByAccountId(condition: {psStatus: 0}) {\n        totalCount\n        nodes {\n          psId\n          psStatus\n          psType\n          ccNum\n          ccExpy\n          ccBrand\n          ccLast4\n          extSource\n          fiName\n          achAccountNum\n          nodeId\n        }\n      }\n      nodeId\n    }\n    nodeId\n  }\n}\n"
  }
};
})();

node.hash = "0cd8f6e8162554731709b2e3039dea7e";

module.exports = node;
